import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div`
	display: grid;
	grid-template-rows: 45px 125px 50px;
	align-items: center;
	justify-content: center;

	h3 {
		color: ${tokens.color_gray_dark};
		text-align: center;
	}
`;

export const Text = styled.p`
	color: ${tokens.color_gray_dark};
	text-align: left;
`;
